<comp-dialog>
  <ng-container comp-dialog-header-title>{{
    'forbidden.accountRequest.action' | translate
  }}</ng-container>
  <ng-container comp-dialog-content>
    <form id="account-request" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (!submitting()) {
        <mat-form-field appearance="outline" [floatLabel]="'always'" class="outlined-form-element">
          <mat-label>{{ 'forbidden.accountRequest.request' | translate }}</mat-label>
          <textarea
            [formControlName]="'request'"
            matInput
            required
            class="outlined-form-element textarea large"
          ></textarea>
        </mat-form-field>
      } @else {
        <mat-spinner diameter="24"></mat-spinner>
      }
    </form>
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" mat-dialog-close>
          {{ 'general.cancel' | translate }}
        </button>
        <button
          comp-button
          type="submit"
          form="account-request"
          [disabled]="form.invalid || submitting()"
        >
          {{ 'general.send' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons></ng-container
  >
</comp-dialog>
